'use client';

import { Typography } from '@mui/material';
import type { MPARequest } from '@repo/api-gw-sdk';
import { BackupPolicyTag } from '@/components/backupPolicy/BackupPolicyTag';
import { useDAL } from '@/contexts/useDAL';
export const getBackupPolicyId = (request: MPARequest | null | undefined) => {
  const path = request?.requestPath;
  if (!path) return null;
  const match = /\/(?:backup-policies|policies)\/([^/?]+)/.exec(path);
  return match?.[1] ?? null;
};
export const getResourceId = (request: MPARequest | null | undefined) => {
  const path = request?.requestPath;
  if (!path) return null;
  const match = /\/resources\/([^/?]+)/.exec(path);
  return match?.[1] ?? null;
};
export const BackupPolicyEntity = ({
  policyId
}: {
  policyId: string | null;
}) => {
  const dal = useDAL();
  const {
    data,
    isLoading
  } = dal.backupPolicy.useList();
  if (!policyId) return null;
  if (isLoading) {
    return <Typography variant='subtitle1' color='text.disabled'>
        Loading...
      </Typography>;
  }
  const policy = data?.backupPolicies?.find(p => p.id === policyId);
  if (!policy) {
    return <Typography variant='subtitle1' color='text.disabled'>
        {policyId}
      </Typography>;
  }
  return <BackupPolicyTag policy={policy} />;
};
export const ResourceEntity = ({
  resourceId
}: {
  resourceId: string | null;
}) => {
  const dal = useDAL();
  const {
    data,
    isLoading
  } = dal.inventory.useResource(resourceId ?? '');
  if (!resourceId) return null;
  if (isLoading) {
    return <Typography variant='subtitle1' color='text.disabled'>
        Loading...
      </Typography>;
  }
  return <Typography variant='h4'>
      {data?.resource?.resourceName || resourceId}
    </Typography>;
};